import { createContext, useEffect, useLayoutEffect, useState } from 'react';
import { SearchTextFieldAllowedPropertiesForTextFieldSearch, SearchTypeEnum, } from 'shared/domains/apollo/generated/types';
import { isUserAgent } from 'shared/domains/common-utils';
import { SearchPopup } from './SearchPopup';
import { useLazySearch } from './useLazySearch';
export const MIN_SEARCH_TEXT_LENGTH = 1;
export const UniversalSearchContext = createContext({});
const initialModifiers = {
    isFuzzy: true,
    searchType: SearchTypeEnum.All,
    searchFields: [
        {
            field: SearchTextFieldAllowedPropertiesForTextFieldSearch.AllApplicable,
        },
    ],
};
export function UniversalSearchProvider(props) {
    const { children } = props;
    const [modifiers, setModifiers] = useState(initialModifiers);
    const [searchText, setSearchText] = useState('');
    const [focusIndex, setFocusIndex] = useState(null);
    const [open, setOpen] = useState(false);
    const { search, data, loading } = useLazySearch();
    const handleSetModifiers = (newModifiers) => {
        setModifiers((prev) => (Object.assign(Object.assign({}, prev), newModifiers)));
    };
    const openSearchPopup = () => {
        setFocusIndex(null);
        setOpen(true);
    };
    const closeSearchPopup = () => {
        setFocusIndex(null);
        setOpen(false);
        setSearchText('');
        setModifiers(initialModifiers);
    };
    useEffect(() => {
        if (open && searchText.length >= MIN_SEARCH_TEXT_LENGTH) {
            search(searchText, modifiers);
        }
    }, [search, searchText, modifiers, open]);
    useLayoutEffect(() => {
        const handleKeyDown = (event) => {
            if (isUserAgent('mac')) {
                if (event.metaKey && event.key === 'k') {
                    event.preventDefault();
                    setOpen(true);
                }
            }
            else if (event.ctrlKey && event.key === 'k') {
                event.preventDefault();
                setOpen(true);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [setOpen]);
    return (<UniversalSearchContext.Provider value={{
            openSearchPopup,
            searchText,
            setSearchText,
            open,
            data,
            loading,
            closeSearchPopup,
            focusIndex,
            setFocusIndex,
            modifiers,
            setModifiers: handleSetModifiers,
        }}>
      <SearchPopup />
      {children}
    </UniversalSearchContext.Provider>);
}
